const notificationReducer = (state = false, action) => {
    if (action.type === 'SET_ORDERS_RETRIEVED') {
        return true
    }
    return state;
};

export default notificationReducer;